// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5376) return "static/chunks/5376-ebb23222d81049cd.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4161 ? "88603698" : chunkId) + "." + {"4161":"3db7f1d03b6df5b2","4534":"e027d044dc18b946","6075":"c384bc6dd2b53db2"}[chunkId] + ".js";
};